import BaseCollection from "lib/collection";
import Restriction from "models/catalog/restriction";
import Ajax from "lib/ajax";
import BaseModel from "lib/model";

export default BaseCollection.extend({
    mainIndex: "id",
    indexes: ["value"],
    model: Restriction,

    removeAll: (catalogId, field, successCallback, failureCallback) => {
        Ajax.sync("delete", new BaseModel(), {
            url: `/api/v3.0/catalog/${catalogId}/restrictions`,
            json: {
                field,
            },
            success: (data) => {
                if (successCallback) {
                    successCallback(data);
                }
            },
            error: (err) => {
                if (failureCallback) {
                    failureCallback(err);
                }
            },
        });
    },

    bulkAdd: (catalogId, restrictions, successCallback, failureCallback) => {
        Ajax.sync("create", new BaseModel(), {
            url: `/api/v3.0/catalog/${catalogId}/restrictions/bulk`,
            json: {
                restrictions,
            },
            success: (data) => {
                if (successCallback) {
                    successCallback(data);
                }
            },
            error: (err) => {
                if (failureCallback) {
                    failureCallback(err);
                }
            },
        });
    },
});
